export default __webpack_public_path__ + "static/media/p6.ce931adf.jpg";